import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export function FrameworkCta() {
  return (
    <div className="bg-[#EAF3F7] border border-zinc-200 rounded-sm p-8 text-center">
      <h3 className="font-display font-bold uppercase text-xl text-zinc-950 mb-3">See the framework behind this</h3>
      <p className="text-zinc-600 text-sm mb-5 max-w-lg mx-auto">
        Every feature on BBAP maps to a specific level of our 7-level Bias Escalation Model.
      </p>
      <Link to="/framework">
        <Button className="bg-zinc-950 text-white rounded-none hover:bg-zinc-900 hover:shadow-[0px_4px_0px_0px_#4FD1C5]">
          Explore the Framework <ArrowRight className="h-4 w-4 ml-2" />
        </Button>
      </Link>
    </div>
  );
}
